import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { paths, ROOTS } from '@/shared/config/paths';
import { withSuspense } from '../utils';
import type { TypedRouteObject } from '../types';

// 동적 임포트
const Program = lazy(() => import('@/pages/program'));
const ProgramList = lazy(() => import('@/pages/program/program/ProgramList'));
const ProgramDetail = lazy(() => import('@/pages/program/program/ProgramDetail'));
const SessionList = lazy(() => import('@/pages/program/session/SessionList'));
const SessionDetail = lazy(() => import('@/pages/program/session/SessionDetail'));
const ProgramEmailList = lazy(() => import ('@/pages/program/email/ProgramEmailList'));

export const programRoutes: TypedRouteObject = {
	path: ROOTS.PROGRAM,
	element: withSuspense(Program),
	handle: {
		title: '프로그램 관리',
		subTitle: '락앤런 정기 프로그램 관리 현황'
	},
	children: [
		{
			index: true,
			element: <Navigate to="list" replace />
		},
		// 프로그램 관리
		{
			path: paths.program.list.path,
			element: withSuspense(ProgramList),
			handle: {
				title: '락앤런 프로그램 관리',
				subTitle: '락앤런 정기 프로그램 관리'
			}
		},
		{
			path: paths.program.detail.path,
			element: withSuspense(ProgramDetail),
			handle: {
				isGoBack: true,
				title: '락앤런 프로그램 관리',
				subTitle: '프로그램 > 프로그램 관리 > 프로그램 상세 정보'
			}
		},
		// 세션 관리
		{
			path: paths.program.session.list.path,
			element: withSuspense(SessionList),
			handle: {
				title: '락앤런 프로그램 회차 관리',
				subTitle: '락앤런 정기 프로그램 회차 관리'
			}
		},
		{
			path: paths.program.session.detail.path,
			element: withSuspense(SessionDetail),
			handle: {
				isGoBack: true,
				title: '락앤런 프로그램 상세정보',
				subTitle: '프로그램 > 신청자관리 > 상세정보'
			}
		},
		// 이메일 발송
		{
			path: paths.program.email.list.path,
			element: withSuspense(ProgramEmailList),
			handle: {
				title: '락앤런 이메일 발송 관리',
				subTitle: '락앤런 프로그램 참가자 이메일 발송 현황 및 관리'
			}
		}
	]
}
